import React from "react";

const Test = () => {
  return <div>Test page</div>;
};

export default Test;
